import { createSlice } from "@reduxjs/toolkit";

const FiltergetSlice = createSlice({
  name: "FilterGet",
  initialState: {
    isLoadingFilter: false,
    isLoadingColor: false,
    isLoadingSize: false,
    isLoadingSHTime: false,
    isLoadingDesigner: false,
    colorData: [],
    sizeData: [],
    shippingTimeData: [],
    designerSellerData: [],
    filterData: [],
    checkedFilterCM: {
      category: [],
      designer: [],
      color: [],
      size: [],
      shippingTime: [],
      discountRangeList: [],
      price: [],
    },
  },
  reducers: {
    clearFilterData: (state, action) => {
      return {
        ...state,
        checkedFilterCM: {
          category: [],
          designer: [],
          color: [],
          size: [],
          shippingTime: [],
          discountRangeList: [],
        },
      };
    },
    checkFLMasterListing: (state, action) => {
      console.log(action.payload, "ACTION");
      const FinalData = {
        ...state?.checkedFilterCM,
        [action?.payload?.name]:
          action?.payload?.name === "price"
            ? [action?.payload?.mainId]
            : state?.checkedFilterCM?.[action?.payload?.name]?.some(
                (e) => e?.uniqId === action?.payload?.mainId?.uniqId
              )
            ? state?.checkedFilterCM?.[action?.payload?.name]?.filter(
                (e) => e?.uniqId !== action?.payload?.mainId?.uniqId
              )
            : [
                ...state?.checkedFilterCM?.[action?.payload?.name],
                action?.payload?.mainId,
              ],
      };
      const PriceData = {
        ...state?.checkedFilterCM,
        [action?.payload?.name]: [action?.payload?.mainId],
      };

      return {
        ...state,
        checkedFilterCM: FinalData,
      };
    },
    deleteCheckFLMasterListing: (state, action) => {
      const FinalData = {
        ...state.checkedFilterCM,
        [action.payload.name]: state.checkedFilterCM?.[
          action.payload.name
        ]?.some((e) => e.uniqId === action?.payload?.uniqId)
          ? state.checkedFilterCM?.[action.payload.name]?.filter(
              (e) => e.uniqId !== action?.payload?.uniqId
            )
          : [
              ...state.checkedFilterCM?.[action.payload.name],
              action?.payload?.uniqId,
            ],
      };
      return {
        ...state,
        checkedFilterCM: FinalData,
      };
    },
    getColorDataRequest(state, action) {
      return {
        ...state,
        isLoadingColor: true,
      };
    },
    getColorDataSuccess(state, action) {
      return {
        ...state,
        isLoadingColor: false,
        colorData: action.payload,
      };
    },
    getColorDataFailure(state, action) {
      return {
        ...state,
        isLoadingColor: false,
      };
    },
    getSizeDataRequest(state, action) {
      return {
        ...state,
        isLoadingSize: true,
      };
    },
    getSizeDataSuccess(state, action) {
      return {
        ...state,
        isLoadingSize: false,
        sizeData: action.payload,
      };
    },
    getSizeDataFailure(state, action) {
      return {
        ...state,
        isLoadingSize: false,
      };
    },
    getShippingTimeDataRequest(state, action) {
      return {
        ...state,
        isLoadingSHTime: true,
      };
    },
    getShippingTimeDataSuccess(state, action) {
      return {
        ...state,
        isLoadingSHTime: false,
        shippingTimeData: action.payload,
      };
    },
    getShippingTimeDataFailure(state, action) {
      return {
        ...state,
        isLoadingSHTime: false,
      };
    },
    getDesignerDataRequest(state, action) {
      return {
        ...state,
        isLoadingDesigner: true,
      };
    },
    getDesignerDataSuccess(state, action) {
      return {
        ...state,
        isLoadingDesigner: false,
        designerSellerData: action.payload,
      };
    },
    getDesignerDataFailure(state, action) {
      return {
        ...state,
        isLoadingDesigner: false,
      };
    },
    getFilterMasterRequest: (state, action) => {
      return {
        ...state,
        isLoadingFilter: true,
      };
    },
    getFilterMasterSuccess: (state, action) => {
      return {
        ...state,
        isLoadingFilter: false,
        filterData: action.payload,
      };
    },
    getFilterMasterFailure: (state, action) => {
      return {
        ...state,
        isLoadingFilter: false,
      };
    },
  },
});

export const {
  getColorDataFailure,
  getColorDataRequest,
  getColorDataSuccess,
  getSizeDataFailure,
  getSizeDataRequest,
  getSizeDataSuccess,
  getShippingTimeDataFailure,
  getShippingTimeDataRequest,
  getShippingTimeDataSuccess,
  getDesignerDataFailure,
  getDesignerDataRequest,
  getDesignerDataSuccess,
  getFilterMasterFailure,
  getFilterMasterRequest,
  getFilterMasterSuccess,
  checkFLMasterListing,
  deleteCheckFLMasterListing,
  clearFilterData,
} = FiltergetSlice.actions;
export default FiltergetSlice.reducer;
